import { router } from '../router/router';
import { api, clearCache } from '../api/api';
import { setApiToken, removeApiToken } from '../api/token';

const AUTH = {
  admin: ['company-owner', 'company-admin'],
};

export const auth = {
  namespaced: true,
  state: {
    loggedIn: false,
    userRoles: [],
    user: null,
  },
  getters: {
    isAdmin(state, _, rootState) {
      const currentCompanyId = rootState.company.currentId;
      if (!currentCompanyId || currentCompanyId === -1) {
        return false;
      }
      const userRole = state.userRoles.find(
        (role) => role.company === currentCompanyId
      );
      return userRole && AUTH.admin.includes(userRole.role);
    },
  },
  mutations: {
    setLoggedIn(state, value) {
      state.loggedIn = value;
    },
    setUserRoles(state, value) {
      state.userRoles = value;
    },
    setUser(state, value) {
      state.user = value;
    },
  },
  actions: {
    async login({ dispatch }, token) {
      dispatch('setToken', token);
      await Promise.all([dispatch('getUserRoles'), dispatch('getUser')]);
      dispatch('company/fetchCompanies', null, { root: true });
    },
    async getUserRoles({ commit }) {
      const { data } = await api.get('user_company_roles/', {
        cache: {
          ignoreCache: true,
        },
      });
      commit('setUserRoles', data);
    },
    async getUser({ commit }) {
      const { data } = await api.get('my_profile/', {
        cache: {
          ignoreCache: true,
        },
      });
      commit('setUser', data);
    },
    setToken({ commit }, token) {
      setApiToken(token);
      commit('setLoggedIn', true);
    },
    logout({ state, commit }) {
      if (!state.loggedIn) {
        return;
      }
      api.post('rest-auth/logout/');
      commit('setLoggedIn', false);
      removeApiToken();
      clearCache();
      router.push({
        name: 'login',
        query: { redirect: router.currentRoute.path },
      });
    },
  },
};
